import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import settingDrawer from "./zh-TW/settingDrawer";
export default _objectSpread({}, settingDrawer);